import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RadioInput } from '@styled';
import fonts from '@general/fonts';

const LabelStyled = styled.label`
    color: black !important;
    cursor: default;
    display: flex;
    font-family: ${fonts.sans};
    font-size: 14px;
    font-style: normal;
    letter-spacing: 0.94px;
    line-height: 22px;
    margin-bottom: 0;
`;

const RadioWithoutForm = ({ checked, id, label, name, value, onChange }) => {
    return (
        <LabelStyled>
            <RadioInput
                checked={checked}
                className="mr-0.5rem"
                id={id}
                name={name}
                type="radio"
                onChange={() => onChange(value)}
            />
            {label && <>{label}</>}
        </LabelStyled>
    );
};

RadioWithoutForm.propTypes = {
    checked: PropTypes.bool.isRequired,
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default RadioWithoutForm;
